import { render, staticRenderFns } from "./CategoryCard.vue?vue&type=template&id=cd0d6b44&scoped=true"
import script from "./CategoryCard.vue?vue&type=script&lang=js"
export * from "./CategoryCard.vue?vue&type=script&lang=js"
import style0 from "./CategoryCard.vue?vue&type=style&index=0&id=cd0d6b44&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0d6b44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd0d6b44')) {
      api.createRecord('cd0d6b44', component.options)
    } else {
      api.reload('cd0d6b44', component.options)
    }
    module.hot.accept("./CategoryCard.vue?vue&type=template&id=cd0d6b44&scoped=true", function () {
      api.rerender('cd0d6b44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CategoryCard.vue"
export default component.exports